import { ChargeTypes } from '@enums/charge-types';
import { AbstractSubscriptionBillingUpdateRequest } from '@models/requests/abstract-subscription-billing-update-request.model';

/**
 * Payload to update a subscription's billing info with a payment method tokenized by Braintree.
 */
export class SubscriptionBillingBraintreeUpdateRequest extends AbstractSubscriptionBillingUpdateRequest {
  public nonce: string;

  public constructor(nonce: string) {
    super(ChargeTypes.braintree);
    this.nonce = nonce;
  }
}
